import moment from 'moment';

/** Platzhalter, wenn kein Wert vorliegt. */
export const EMPTY_VALUE = '-';

/**
 * Datum zur Anzeige, im projektweiten Format DD.MM.YYYY.
 * Nimmt Date, Zeichenkette oder null - ohne verwertbaren Wert kommt "-" zurück.
 */
export function toDate(value?: Date | string | null): string {
  if (!value) {
    return EMPTY_VALUE;
  }

  const m = moment(value);

  return m.isValid() ? m.format('DD.MM.YYYY') : EMPTY_VALUE;
}

/** Wie toDate, zusätzlich mit Uhrzeit - DD.MM.YYYY HH:mm. */
export function toDateTime(value?: Date | string | null): string {
  if (!value) {
    return EMPTY_VALUE;
  }

  const m = moment(value);

  return m.isValid() ? m.format('DD.MM.YYYY HH:mm') : EMPTY_VALUE;
}

export function makeSafeFileName(rawSerial: string | number): string {
      const str = String(rawSerial).trim();
      
      // Entfernt nur wirklich verbotene Zeichen (Windows-kompatibel)
      return str.replace(/[<>:"\/\\|?*\x00-\x1F]/g, "_")
                .replace(/^\.+|\.+$/g, "")           // optional
                .replace(/^_+|_+$/g, "");            // optional
    }
